// ----------------------------------------------------------------------

export default function Tabs(theme) {
  return {
    MuiTab: {
      styleOverrides: {
        root: {
          padding: 0,
          paddingLeft: theme.spacing(4),
          paddingRight: theme.spacing(4),
          fontWeight: theme.typography.fontWeightMedium,
          borderTopLeftRadius: theme.shape.borderRadius,
          borderTopRightRadius: theme.shape.borderRadius,
          color: `${theme.palette.grey[700]}!important`,
          fontWeight: 400,
          '&.Mui-selected': {
            color: `#FCFCFC !important`,
            background: `${theme.palette.primary.main} !important`,
            fontWeight: 500,
            'svg':{
              color: `#FCFCFC !important`,
            }
          },
          '&:not(:last-of-type)': {
            // paddingRight: theme.spacing(5),
          },
          '@media (min-width: 600px)': {
            minWidth: 48,
          },
          'svg':{
            color: 'transparent'
          }
        },
        labelIcon: {
          minHeight: 48,
          flexDirection: 'row',
          '& > *:first-of-type': {
            marginBottom: 0,
            marginRight: theme.spacing(1),
          },
        },
        wrapper: {
          flexDirection: 'row',
          whiteSpace: 'nowrap',
        },
        textColorInherit: {
          opacity: 1,
          color: theme.palette.grey[900],
        },
      },
    },
    MuiTabPanel: {
      styleOverrides: {
        root: {
          padding: 0,
        },
      },
    },
    MuiTabScrollButton: {
      styleOverrides: {
        root: {
          width: 48,
          borderRadius: '50%',
        },
      },
    },
  };
}
